import script from "./EditSellers.vue?vue&type=script&setup=true&lang=js"
export * from "./EditSellers.vue?vue&type=script&setup=true&lang=js"

import "./EditSellers.vue?vue&type=style&index=0&id=02a6caff&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02a6caff"]])

export default __exports__